import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'issues'
})
export class IssuesPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
